import SharedManagementScreen from "../../shared/management/managementScreen";
import { configs } from "./definitions";
import { getSectionProvider } from "./sections/registry";

const mvpDefinition = {
  id: "mvp",
  defaultSection: "accounts",
  tabs: [
    { label: "Account Management", value: "accounts" },
    { label: "User Management", value: "users" },
  ],
};

function getMvpManagementDefinition() {
  return mvpDefinition;
}

export default function ManagementScreen({ experience = "mvp" }) {
  return (
    <SharedManagementScreen
      definition={getMvpManagementDefinition()}
      sectionConfigs={configs}
      sectionProviderResolver={getSectionProvider}
      experience={experience}
    />
  );
}
